import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import PropTypes from 'prop-types';
import './styles.css';

class LazyLoadSelect extends React.Component {
  onChange = selectedOption => {
    this.props.controlFunc(selectedOption, this.props.name);
  };
  getOption = async (inputValue, loadedOptions) => {
    const response = await this.props.getOption(
      inputValue,
      loadedOptions.length
    );
    if (!response.hasMore && response.has_more) {
      response.hasMore = response.has_more;
    }
    return response;
  };

  handleChange = selectedOption => {
    if (this.props.onChange) {
      this.props.onChange(this.props.name, selectedOption);
    } else {
      this.props.controlFunc(selectedOption, this.props.name);
    }
  };

  handleOnBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name, true);
    } else if (this.props.touchFunc) {
      this.props.touchFunc(e);
    }
  };

  render() {
    const {
      name,
      isValid,
      label,
      required,
      placeholder,
      debounceTimeout,
      filterOption,
      controlInputChangeFunc,
      labelStyles,
      value,
      disabled,
      cacheUniq = false,
      isClearable = false,
    } = this.props;

    const isRequired = required
      ? 'lazy-load-select__label-text lazy-load-select__label-text--required'
      : 'lazy-load-select__label-text';

    const customStyles = {
      control: base => ({
        ...base,
        borderColor: isValid ? '#a0a0a0' : '#f40',
      }),
    };

    return (
      <div className="lazy-load-select__wrapper">
        {label && (
          <label
            className="lazy-load-select__label"
            htmlFor={name}
            style={labelStyles}
          >
            <span className={isRequired}>{label}</span>
          </label>
        )}
        <AsyncPaginate
          cacheUniq={cacheUniq}
          isDisabled={disabled}
          blurInputOnSelect
          instanceId={Date.now()}
          styles={customStyles}
          value={value}
          name={name}
          filterOption={filterOption || null}
          debounceTimeout={debounceTimeout || 500}
          placeholder={placeholder}
          loadOptions={this.getOption}
          onChange={this.handleChange}
          onInputChange={controlInputChangeFunc}
          className="lazy-load-select"
          classNamePrefix="lazy-load-select"
          onBlur={this.handleOnBlur}
          isClearable={isClearable}
        />
      </div>
    );
  }
}

LazyLoadSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  cacheUniq: PropTypes.any,
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  required: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  filterOption: PropTypes.func,
  getOption: PropTypes.func.isRequired,
  controlFunc: PropTypes.func,
  onChange: PropTypes.func,
  controlInputChangeFunc: PropTypes.func,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  touchFunc: PropTypes.func,
  onBlur: PropTypes.func,
  isClearable: PropTypes.bool,
  debounceTimeout: PropTypes.number,
};

export default LazyLoadSelect;
